import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import 'dayjs/locale/en-gb';
import Button, { ButtonStyle } from '../../common/components/Button/Button';
import ButtonContainer from '../../common/components/Button/ButtonContainer';
import Container from '../../common/components/Container/Container';
import TitleContainer from '../../common/components/TitleContainer/TitleContainer';
import { FlowConfigContext } from '../../providers/FlowConfigContext';
import { Provider } from '../../config';
import { AuthenticationContext } from '../../providers/AuthenticationContext';
import withRouteAnalytics from '../../services/analytics/withRouteAnalytics';
import AuthTokenEventPayload from '../../services/events/authTokenEventPayload';
import { Screens } from '../../services/analytics/screens';

function CivicDemoScreen(): JSX.Element {
  const { t } = useTranslation();

  const { flowSuccessful, flowFailed } = useContext(FlowConfigContext);
  const { getCurrentToken } = useContext(AuthenticationContext);

  const handleConfirm = async () => {
    const tokenResult = await getCurrentToken();
    if (tokenResult.isFailed()) {
      tokenResult.logError();
      flowFailed({ provider: Provider.MARKETING });
      return;
    }
    flowSuccessful(new AuthTokenEventPayload(tokenResult.success()));
  };

  return (
    <Container>
      <TitleContainer center>
        <h1 data-testid="CIVIC_DEMO_CAPTURE_HEADER">{t('screens.civicDemoPass.capture.title')}</h1>
      </TitleContainer>
      <div className="w-full h-80 flex justify-center items-center -my-2">
        <img src="civic-pass-marketing.svg" alt="Description" />
      </div>
      <div className="text-lg font-bold leading-6 mt-2" data-testid="DEMO_CONTENT">
        <span>{t('screens.civicDemoPass.capture.description_1')}</span>
        <span className="text-textParagraph"> | </span>
        <span>{t('screens.civicDemoPass.capture.description_2')}</span>
        <span className="text-textParagraph"> | </span>
        <span>{t('screens.civicDemoPass.capture.description_3')}</span>
        <span className="text-textParagraph"> | </span>
        <span>{t('screens.civicDemoPass.capture.description_4')}</span>
      </div>
      <div className="text-lg font-extralight text-textNeutral leading-6 mt-1 mb-6" data-testid="DEMO_CONENT">
        {t('screens.civicDemoPass.capture.description_more')}
      </div>

      <ButtonContainer>
        <Button style={ButtonStyle.DEFAULT} onClick={handleConfirm} dataTestid="CONTINUE_BUTTON" disabled={false}>
          <span>{t('screens.civicDemoPass.capture.continueButton')}</span>
        </Button>
      </ButtonContainer>
    </Container>
  );
}

export default withRouteAnalytics(CivicDemoScreen, Screens.CIVIC_DEMO);
